// extracted by mini-css-extract-plugin
module.exports = {"screen":"screen__lPMUp9Bsdz2Ox","noRights":"noRights__E5iPPXiL+YG-f","popupIcon":"popupIcon__McqWkQrSPsPJP","block":"block__MJmubadov9qbP"};